import { useEffect, useState } from "react";
import { crearDatos } from "../../api/common";
import { useAuth } from '../../hooks/useAuth';
import Modal from "../commons/Modal";
import NewEventCalendar from "./newEventCalendar";
import { Modales } from "../Modales";



export function AddEventCalendar({setEvents, events, isOpen, setIsOpen, setRefresh}) {
    
    return(
        <>
            <span className="button-add" onClick={() => setIsOpen(true)}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-plus-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"/>
            </svg>
            </span>

            <Modales
                estado={isOpen} 
                cambiarestado={setIsOpen}
                titulo={"Nuevo Evento"}
            >
                <NewEventCalendar setEvents={setEvents} events={events} setIsOpen={setIsOpen} setRefresh={setRefresh}/>
            </Modales>
        </>
    )
}